import React, { useEffect, useState } from 'react'
import classnames from 'classnames'
import { Router, useRouter } from 'next/router'

interface IProps {
  seriesId: number
  seriesName: string
  dealerPrice: string
  titles: {
    name: string
    url?: string
    el?: string
    outer?: boolean
  }[]
  activeIndex?: string
  handleAnchorClick?: (name: string) => void
}

export default function TopAnchor({ params }: { params: IProps }) {
  const { titles, activeIndex, handleAnchorClick } = params

  const [currIndex, setCurrIndex] = useState(0)
  const router = useRouter()

  useEffect(() => {
    switch (activeIndex) {
    case 'home':
      setCurrIndex(0)
      break
    case 'article':
      setCurrIndex(5)
      break
    case 'video':
      setCurrIndex(6)
      break
    case 'qa':
      setCurrIndex(3)
      break
    }
  }, [activeIndex])

  return (
    <section id="anchor-nav">
      <ul>
        {titles.map((item, index: number) => (
          <li
            key={index.toString()}
            className={classnames({
              active: currIndex === index,
              'tw-mx-16': true,
            })}
            onClick={(e) => {
              if (!item.url || currIndex === index) return
              if (item.outer) {
                window.open(item.url)
              } else {
                router.push(item.url)
              }
              if (typeof handleAnchorClick === 'function') {
                handleAnchorClick(item.name)
              }
            }}
          >
            <span className="tw-text-base md:tw-text-lg">{item.name}</span>
          </li>
        ))}
      </ul>

      <style jsx>
        {`
          section {
            height: 60px;
            margin: 0 auto;
            margin-bottom: 8px;
          }
          .fix {
            width: 100%;
            background-color: #1f2129;
          }
          ul {
            margin: 0 auto;
            height: 100%;
            padding-left: 16px;
            display: flex;
            font-size: 18px;
            color: #c9cbd6;
            background-color: #1f2129;
          }
          ul li {
            position: relative;
            height: 100%;
            line-height: 60px;
            cursor: pointer;
          }
          ul li:hover {
            color: white;
          }
          ul li:first-child {
            padding-left: 0;
          }
          li span {
            position: relative;
          }
          .active span::after {
            content: '';
            display: inline-block;
            width: 100%;
            height: 4px;
            position: absolute;
            bottom: -18px;
            left: 0;
            background-color: #ffe100;
          }
          .active {
            color: #f7f8fc;
            font-weight: 500;
          }
          #anchor-nav :global(span.button) {
            position: absolute;
            right: 0;
            top: 18px;
            min-width: 96px;
            height: 32px;
            line-height: 32px;
            display: none;
            font-weight: normal;
            font-size: 16px;
            border-radius: 2px;
          }
        `}
      </style>
    </section>
  )
}
